import { AutogenModelRevenueCode, AutogenRowRevenueCode } from "./autogen/AutogenModelRevenueCode";

export class ModelRevenueCode extends AutogenModelRevenueCode<RowRevenueCode> {
    constructor() {
        super(RowRevenueCode);
    }
}

export class RowRevenueCode extends AutogenRowRevenueCode {
}